import {
  Globe
} from 'lucide-react'
import {
  formatTimezoneName
} from './schedulingUtils'

export function TimezoneSelector({
  guestTimezone,
  linkTimezone,
  ownerName,
  sameTimezone,
  displayTimezone,
  onChange
}: {
  guestTimezone: string,
  linkTimezone: string,
  ownerName: string | null,
  sameTimezone: boolean,
  displayTimezone: string,
  onChange: (tz: string) => void
}): JSX.Element {
  return (
    <div className="flex items-center gap-1.5 text-sm text-gray-500">
      <Globe className="w-4 h-4 shrink-0 text-gray-400" />
      {sameTimezone ? (
        <span>{formatTimezoneName(displayTimezone)}</span>
      ) : (
        <select
          value={displayTimezone}
          onChange={(e) => onChange(e.target.value)}
          className="bg-transparent border-none cursor-pointer p-0 pr-1 text-gray-500 focus:outline-none focus:ring-0"
        >
          <option value={guestTimezone}>
            Your timezone ({formatTimezoneName(guestTimezone)})
          </option>
          <option value={linkTimezone}>
            {ownerName ? `${ownerName}'s` : 'Organizer'} timezone ({formatTimezoneName(linkTimezone)})
          </option>
        </select>
      )}
    </div>
  )
}
